export default __webpack_public_path__ + "static/media/G-4.b1e866cc.svg";